// extracted by mini-css-extract-plugin
export default {"body":"body_zHskj","desc":"desc_MmiO7","images":"images_k8RPI","item":"item_KjGTx"};